/*
 * @Author: Huangxianlong
 * @Date: 2023-10-19 09:27:10
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-11-18 11:18:04
 * @FilePath: \monitor\src\store\modules\project.js
 * @Description: 
 */
import * as api from "../../api";
import Tools from "@/libs/tools";
import { router } from "../../router/index";

const project = {
  state: {
    projectList: [],
    projectId:''
  },
  mutations: {
    //项目数据
    getProjectListMutation(state, data) {
      state.projectList = data;
    },
    //项目id
    setProjectIdMutation(state, data) {
      state.projectId = data;
    }
  },
  getters: {
    getProjectList(state) {
      return state.projectList;
    }
  },
  actions: {
    getProjectListAction({ commit }, params) {
      const param = {
        pageNum: 1,
        pageSize: 100,
        userId: Tools.methods.StorageGet("loginInfo").userId,
        order:"project_name",
      };
      return api.getAllProjectInfoResource(param).then(response => {
        commit("getProjectListMutation", response.body);
        //保存登陆用户信息
        Tools.methods.StorageSet({
          key: "projectList",
          val: response.body.list
        });
        return response.body;
      });
    }
  }
};

export default project;



// WEBPACK FOOTER //
// ./src/store/modules/project.js